'use client';

import { Tab } from '@common/components';

import { ROUTES } from '@/constants';
import { useCustomRouter } from '@/hooks/useCustomRouter';
import { useHaptic } from '@/hooks/useHaptic';

import {
  BENEFIT_HOME_TAB,
  BENEFIT_HOME_TABS_ID,
  type BenefitHomeTab,
} from '../_constants';

interface BenefitHomeTabsProps {
  activeTab: BenefitHomeTab;
}

export const BenefitHomeTabs = ({ activeTab }: BenefitHomeTabsProps) => {
  const router = useCustomRouter();
  const { triggerHaptic } = useHaptic();

  const handleChange = (tab: string) => {
    triggerHaptic();
    router.replace(
      ROUTES.BENEFIT.withSearchParams({
        searchParams: { tab: tab as BenefitHomeTab },
      }),
      { scroll: false },
    );
  };

  //* 모바일은 퀵메뉴 회색 띠 위에 둥근 윗변 카드로 얹힌다.
  return (
    <div id={BENEFIT_HOME_TABS_ID} className="bg-Gray-25 xl:bg-transparent">
      <div className="rounded-t-xxlarge bg-Gray-white pt-12 xl:rounded-none xl:bg-transparent xl:pt-0">
        <Tab value={activeTab} onChange={handleChange}>
          <Tab.Item value={BENEFIT_HOME_TAB.EARN}>모으기</Tab.Item>
          <Tab.Item value={BENEFIT_HOME_TAB.USE}>사용하기</Tab.Item>
        </Tab>
      </div>
    </div>
  );
};
